import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4509 4.08872C12.6781 4.24571 12.735 4.55714 12.578 4.78431L8.14508 11.1986L8.14507 11.1987C7.42761 12.2368 5.90028 12.2566 5.15616 11.2374L5.55998 10.9426L5.15616 11.2374L3.42953 8.87255C3.26669 8.64953 3.31549 8.33673 3.53851 8.17389C3.76153 8.01106 4.07433 8.05985 4.23717 8.28288L5.9638 10.6477C6.30202 11.111 6.99628 11.102 7.32242 10.6301C7.32242 10.6301 7.32242 10.6301 7.32242 10.6301L11.7554 4.21578C11.9123 3.98861 12.2238 3.93172 12.4509 4.08872Z"
      fill="currentColor"
    />
  </SvgIcon>
));
